<template>
  <v-autocomplete
    v-model="state"
    :items="statesFormatted"
    hide-details
    solo
    flat
    @change="$emit('on-change',state)"
  ></v-autocomplete>
</template>

<script>
import stateList from '@/consts/locationStates';

export default {
  name: 'StateSelect',
  props: ['prefill'],
  data () {
    return {
      state: (this.prefill || null),
      states: stateList
    }
  },
  computed: {
    statesFormatted: function() {
      let states = [];
      for(let i = 0; i < Object.keys(this.states).length; i++) {
        let key = Object.keys(this.states)[i];
        let state = this.states[ key ];
        states.push({text:state,value:key});
      }
      return states;
    }
  },
  methods: {
    
  }
}
</script>